export default __webpack_public_path__ + "static/intro-bd5e6cf3fc89d2335f7dd8a300135869.gif";